// The a plus promo in the filters is shown for groups of refinements.
// This is mapping of those refinement attributs to the group
const category = {
  value: "category"
};

const type = {
  value: "type"
};

const timePeriod = {
  value: "timePeriod"
};

const literaryPeriod = {
  value: "literaryPeriod"
};

const literaryMovement = {
  value: "literaryMovement"
};

const author = {
  value: "author"
};

const gradeLevel = {
  value: "gradeLevel"
};

export default {
  authorEthnicity: author,
  authorGender: author,
  authorNationality: author,
  category,
  genre: type,
  gradeLevel,
  literaryMovement,
  literaryPeriod,
  timePeriod,
  type
};
